import React from "react";
import Button from "@material-ui/core/Button";
import CircularProgress from "@material-ui/core/CircularProgress";

export default function LoadingButton({ loading, children, ...props }) {
  return (
    <Button disabled={loading} {...props}>
      {loading ? (
        <>
          <CircularProgress size={18} style={{marginRight:'5px'}} />
          {children}
        </>
      ) : (
        children
      )}
    </Button>
  );
}
